import './sign-in-form.scss'
import { useState ,useContext} from 'react';
import { Button } from '../button/button';
import {FormInput} from '../form-input/form-input';
import  {UserContext} from '../contexts/user.context'
import {
    createAuthUserWithEmailAndPassword,
    signInAuthUserWithEmailAndPassword,
    signInWithGooglePopup,
    createUserDocumentFromAuth} from '../../utils/firebase/firebase.utils'
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const defaultFormField={
    email:'',
    password:'',
}
export const SignInForm =()=>{
    const [formFields, setFormField] =useState(defaultFormField);
    const {email,password} = formFields;
    console.log(formFields);

    const { setCurrentUser} = useContext(UserContext);
      //-----------------------------
    const SignInWithGoogle = async () => {
        const {user}= await signInWithGooglePopup();
        await createUserDocumentFromAuth(user);
        };
    //-------------------------------------------------- 
    const resetFormFields=()=>{
        setFormField(defaultFormField);
    }
    //--------------------------------------
    const handleSubmit = async (event)=>{
        event.preventDefault();
        try{
            const res = await signInAuthUserWithEmailAndPassword(email,password);
            setCurrentUser(res.user);
            console.log("signIN Auth response.user = ",res.user);
            resetFormFields();
            alert("success to sign In 😄 ");
        }catch(err){
            switch(err.code){
                case 'auth/wrong-password':
                    alert("incorrect password for email");
                    break;

                case 'auth/user-not-found':
                    alert("no user associated with this email");
                    break;
                default: console.log("error in authentication = ",err);
            }

           console.log("error = ",err);
        }
    }

    //---------------------------------------------------
    const handleChange = (event) =>{
        const {name,value} = event.target;
        setFormField({...formFields,[name]:value});
    }
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    return(
        <div className='sign-up-container'>
            <h2 id='account1'>Already have an account?</h2>
            <span>Sign In with your email and password</span>
            <form className='signUpForm' onSubmit={handleSubmit}>
              
                <FormInput label="Email" 
                type="email" required 
                onChange={handleChange} 
                name='email' value={email} />
               
                <FormInput label="Password" 
                type="password" required 
                onChange={handleChange} 
                name='password' value={password} />
            <div className='containerButtons'>
                <Button buttonType={'inverted'} type={'submit'}>Sign In</Button>
                {/* <Button onClick={SignInWithGoogle}>Sign In With Google</Button> */}
                <button className='btngoogle' onClick={SignInWithGoogle}>
                    <div className="google-btn">
                         <div className="google-icon-wrapper">
                            <img className="google-icon" 
                              src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
                         </div>
                         <p className="btn-text"><b>Sign in with google</b></p>
                    </div>
                </button>
            </div>
          </form>
        </div>
    );
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
}

//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx